import initialState from "./initialState";

export function SmartOrderDashboardReducer(
  state = initialState.SmartOrderDashboardReducer,
  action
) {
  switch (action.type) {
    case "SMART_ORDER_DASHBOARD_REQUEST":
      return action.payload;

    default:
      return state;
  }
}
